export const Texts = {
  state: () => ({
    data: []
  })
}
